<breadcrumb
  [paginas]="[
    { route: '/home', name: 'Home' },
    { route: '/registro-saida', name: 'Registrar saída da escola' },
    { route: '/#', name: 'Editar Registro de atividade' }
  ]"
/>
<section class="section-filtro filtro-disabled">
  <app-filtro-padrao
    (filtroEmitter)="searchHandler($event)"
    [template]="2"
    [style]="1"
  ></app-filtro-padrao>
</section>

<!-- TITULO -->
<section class="section-saudacao">
  <div class="container">
    <h2 class="titulo-page">Editar Registro de atividade</h2>
    <app-btn-back class="btn_voltar_consulta"></app-btn-back>
  </div>
</section>

<section class="section-grid-consulta-ponto">
  <form [formGroup]="formEditar" (submit)="editarAtividade()">
    <div class="container">
      <!-- dataAtividade -->
       <div class="row-duas-colunas">
        <div class="col">
          <div class="grupo-filter-full">
            <label for="dataAtividade">Data da Visita à URE/Escola</label>
            <input type="datetime-local" id="dataAtividade" name="dataAtividade" formControlName="dataAtividade" readonly>
            <div
            *ngIf="submitted && formEditar.get('dataAtividade')?.errors"
            class="alert"
          >
            <div *ngIf="formEditar.get('dataAtividade')?.errors?.required">
              * Data da atividade é obrigatório
            </div>
        </div>
          </div>
        </div>
        <div class="col">
          <div class="grupo-filter-full">
            <label for="dataOperacao">Data do Registro</label>
            <input type="datetime-local" id="dataOperacao" name="dataOperacao" formControlName="dataOperacao" readonly>
          </div>
        </div>
      </div>

      <label for="select-gravidade">Psicólogo</label>
      <ng-select
        [items]="[
          { codigoPsicologo: userLogado?.nome, nomePsicologo: userLogado?.nome }
        ]"
        bindLabel="nomePsicologo"
        bindValue="nomePsicologo"
        formControlName="nomePsicologo"
        [readonly]="true"
        [searchable]="false"
        [clearable]="false"
      >
      </ng-select>

      <div class="grupo-filter-full">
        <label for="select-gravidade">Titulo</label>
        <input
          type="text"
          id="tituloAcao"
          name="descricaoTituloAcao"
          maxlength="500"
          formControlName="tituloAcao"
        />
        <div
          *ngIf="submitted && formEditar.get('tituloAcao')?.errors"
          class="alert"
        >
          <div *ngIf="formEditar.get('tituloAcao')?.errors?.required">
            * Titulo é obrigatório
          </div>
        </div>
      </div>

      <label for="duracaoAcao">Quanto tempo durou a ação?</label>
      <div class="slider-container">
        <input-range formControlName="duracaoAcao" />
      </div>

      <div class="grupo-filter-full">
        <label for="tipoAtividade">Tipo de atividade</label>
        <ng-select
          [items]="tiposAtividade"
          bindLabel="label"
          bindValue="value"
          formControlName="tipoAtividade"
          placeholder="Selecione o tipo de atividade"
          [searchable]="false"
          [clearable]="false"
          (change)="onTipoAtividadeChange($event)"
        >
        </ng-select>
      </div>

      <!-- ///////////////////////////////////////////////Prevenção Agendada e Acolhimento agendado//////////////////////////////////////////// -->
      <div class="conteudo-envolvidos" *ngIf="mostrarAgendados">
         <div class="grupo-filter" *ngIf="!this.filtros?.codigoEscola">
          <p><b>Escola</b></p>
          <ng-select
            [items]="escolas"
            bindLabel="nomeEscola"
            bindValue="codigoEscola"
            placeholder="Selecione uma Escola"
            name="codigoEscola"
            formControlName="codigoEscolaApenasDiretoria"
            (change)="onChangeCodigoEscola()"
            aria-describedby="escolas-error"
          >
          </ng-select>
        </div>

        <div class="grupo-filter-full" *ngIf="mostrarGridAcolhimento">
          <app-tabulator-table
            [columnNames]="gridAcolhimentoAgendado"
            [tipoRelatorio]="2"
            [tableData]="lstOcorrenciasAgendadas"
            [orientacaoPortrait]="false"
          >
          </app-tabulator-table>
        </div>

        <div class="grupo-filter-full" *ngIf="mostrarGridPrevencao">
          <app-tabulator-table
            [columnNames]="gridPrevencaoAgendado"
            [tipoRelatorio]="2"
            [tableData]="lstAgendamentoPrevencao"
            [orientacaoPortrait]="false"
          >
          </app-tabulator-table>
        </div>

        <div class="conteudo-envolvidos" *ngIf="mostrarAlunos">
          <h3>Envolvido</h3>

          <div class="envolvidos-aluno">
            <div
              class="perfil-aluno-chamado"
              *ngFor="let envolvido of lstEnvolvidos"
            >
              <input
                type="checkbox"
                class="check-envolvidos"
                (click)="
                  addEnvolvidoOnLstEnvolvidoSelecionado(
                    envolvido.codigoEnvolvido!,
                    $event.target!
                  )
                "
                [checked]="IsEnvolvidoSelected(envolvido)"
                [disabled]="atividade.codigoAgendamento !== undefined"
              />
              <div class="img-aluno">
                <span>{{ envolvido.iniciais }}</span>
              </div>
              <div class="infor-aluno-chamado">
                <p class="nome-aluno">{{ envolvido.nome }}</p>
                <p class="descricao">
                  {{ envolvido.dsTipoPessoa }} - {{ envolvido.dsEnvolvido }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ///////////////////////////////////////////////Prevenção não Agendada e Acolhimento não agendado//////////////////////////////////////////// -->
      <div class="conteudo-envolvidos" *ngIf="mostrarNaoAgendados">
        <!-- <div class="conteudo-select" *ngIf="showOpcoesPrevencao"> -->
        <label for="select-gravidade">Qual atividade foi realizada?</label>
        <ng-select
          [items]="lstAtividadeRealizada"
          bindLabel="name"
          bindValue="id"
          placeholder="Selecione o tipo de atividade"
          name="atividadeRealizada"
          formControlName="atividadeRealizada"
          (change)="opcoesPrevencao()"
        >
        </ng-select>
        <!-- </div> -->

        <div class="conteudo-envolvidos" *ngIf="mostrarAlunosPrevencao">
          <h3>Estudantes</h3>
          <div class="content-person">
            <a
              href="javascript:void(0)"
              class="btn-add-person btn-gg"
              (click)="AbreModalAluno()"
            >
              <img src="../../../../assets/img/icons/icon-add.svg" alt="" />
            </a>
          </div>
          @for (aluno of alunosSelecionados; track $index;) {
          <div class="grupo-filter-full">
            <label for="select-gravidade">
              Aluno(a)
              <a
                href="javascript:void(0)"
                class="btn-close-convidados"
                (click)="removeAluno(aluno.codigoAluno!)"
              ></a>
            </label>
            <input
              type="text"
              id="func-{{ $index }}"
              name="funcionario"
              readonly
              [value]="aluno.nomeAluno"
            />
          </div>
          }@empty { Nenhum aluno adicionado. }
        </div>

        <div class="conteudo-envolvidos" *ngIf="mostrarGrupos">
          <label for="select-gravidade">Atividade em grupo</label>
          <ng-select
            [items]="lstGrupos"
            bindLabel="name"
            bindValue="id"
            placeholder="Selecione o tipo de grupos"
            name="tipoGrupo"
            formControlName="tipoGrupo"
            (change)="mostrarTipoGrupo()"
          >
          </ng-select>
        </div>

        <div class="conteudo-envolvidos" *ngIf="mostrarDivTurmas">
             <div class="grupo-filter" *ngIf="!this.jornada?.codigoEscola">
              <p><b>Escola</b></p>
              <ng-select
                [items]="escolas"
                bindLabel="nomeEscola"
                bindValue="codigoEscola"
                placeholder="Selecione uma Escola"
                name="codigoEscola"
                formControlName="codigoEscolaApenasDiretoria"
                (change)="onChangeCodigoEscola()"
                aria-describedby="escolas-error"
              >
              </ng-select>

        </div>

          <section class="conteudo-principal" *ngIf="this.formControls.codigoEscolaApenasDiretoria.value">
            <div class="container">
              <div class="conteudo-perfil">
                <br />
                <label for="select-gravidade">Turmas</label>
                <div class="grid-datatable">
                  <app-tabulator-table
                    [columnNames]="gridTurmasPrevencao"
                    [tipoRelatorio]="2"
                    [tableData]="lstTurmas"
                    [orientacaoPortrait]="false"
                    [mostrarFiltro]="false"
                  >
                  </app-tabulator-table>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div class="conteudo-envolvidos" *ngIf="mostrarDivEquipeEscolar">
          <h3>Envolvidos</h3>

          <label for="select-gravidade"> Equipe Escolar </label>
          <div class="content-person">
            <a
              href="javascript:void(0)"
              class="btn-add-person btn-gg"
              (click)="AbrirModalEquipeEscolar()"
            >
              <img src="../../../../assets/img/icons/icon-add.svg" alt="" />
            </a>
          </div>
          <div
            class="grupo-filter-full"
            *ngFor="let envolvido of lstFuncionariosSelecionados; let i = index"
          >
            <label for="select-gravidade">
              <a
                href="javascript:void(0)"
                class="btn-close-convidados"
                (click)="OnExcluirEquipeEscolar(envolvido)"
              >
              </a>
            </label>
            <input
              [readOnly]="true"
              type="text"
              id="envolvido-{{ i }}"
              name="tituloVisita"
              [value]="envolvido.nome"
            />
          </div>
        </div>

        <div class="conteudo-envolvidos" *ngIf="mostrarDivOutros">
          <h3>Envolvidos</h3>
          <label for="select-gravidade"> Outros </label>
          <div class="content-person">
            <a
              href="javascript:void(0)"
              class="btn-add-person btn-gg"
              (click)="AbrirModalOutros()"
            >
              <img src="../../../../assets/img/icons/icon-add.svg" alt="" />
            </a>
          </div>
          <div
            class="grupo-filter-full"
            *ngFor="let outro of lstOutros; let i = index"
          >
            <label for="select-gravidade">
              <a
                href="javascript:void(0)"
                class="btn-close-convidados"
                (click)="OnExcluirOutro(outro)"
              >
              </a>
            </label>
            <input
              [readOnly]="true"
              type="text"
              id="envolvido-{{ i }}"
              name="text-titulo"
              [value]="outro"
            />
          </div>
        </div>
      </div>

      <div class="grupo-filter-full">
        <label for="text-descricao">Ação Realizada:</label>
        <div class="textarea-container">
          <textarea
            id="codigoAcaoRealizada"
            name="descricaoAcaoRealizada"
            rows="6"
            cols="40"
            minlength="50"
            maxlength="500"
            (keyup)="OnChangeCountLetters(1)"
            formControlName="acaoRealizada"
            [(ngModel)]="descricaoAcaoRealizada"
          ></textarea>
          <i
            class="mdi mdi-microphone mic-icon"
            (click)="toggleListeningAcaoRealizada()"
            [ngClass]="{ glow: isListening }"
            >microphone</i
          >
        </div>
        <p>Quantidade de caracteres atual: {{ qtdeCaracteresAcao }}</p>
        <div
          *ngIf="
            formEditar.get('acaoRealizada')?.errors &&
            (formEditar.get('acaoRealizada')?.touched ||
              formEditar.get('acaoRealizada')?.dirty)
          "
          class="alert"
        >
          <div *ngIf="formEditar.get('acaoRealizada')?.errors?.required">
            * Ação obrigatória
          </div>
          <div *ngIf="formEditar.get('acaoRealizada')?.errors?.minlength">
            * É obrigatório no mínimo digitar 50 caracteres.
          </div>
          <div *ngIf="formEditar.get('acaoRealizada')?.errors?.maxlength">
            * Máximo de caracteres é 500.
          </div>
        </div>
      </div>

      <div class="grupo-filter-full">
        <label for="text-descricao">Próximos Passos:</label>
        <div class="textarea-container">
          <textarea
            id="codigoProximosPassos"
            name="descricaoProximosPassos"
            rows="6"
            cols="40"
            minlength="50"
            maxlength="500"
            (keyup)="OnChangeCountLetters(2)"
            formControlName="proximosPassos"
            [(ngModel)]="descricaoProximosPassos"
          ></textarea>
          <i
            class="mdi mdi-microphone mic-icon"
            (click)="toggleListeningProximosPassos()"
            [ngClass]="{ glow: isListening }"
            >microphone</i
          >
        </div>
        <p>Quantidade de caracteres atual: {{ qtdeCaracteresPassos }}</p>
        <div
          *ngIf="
            formEditar.get('proximosPassos')?.errors &&
            (formEditar.get('proximosPassos')?.touched ||
              formEditar.get('proximosPassos')?.dirty)
          "
          class="alert"
        >
          <div *ngIf="formEditar.get('proximosPassos')?.errors?.required">
            * É obrigatório preencher esse campo
          </div>
          <div *ngIf="formEditar.get('proximosPassos')?.errors?.minlength">
            * É obrigatório no mínimo digitar 50 caracteres.
          </div>
          <div *ngIf="formEditar.get('proximosPassos')?.errors?.maxlength">
            * Máximo de caracteres é 500.
          </div>
        </div>
      </div>

      <div class="conteudo-upload grupo-filter-full">
        <label>Inserir documentos, fotos, áudios (MP3) ou vídeos (MP4).</label>
        <div class="input-upload">
          <input
            type="file"
            id="arquivos"
            name="arquivos"
            accept=".jpg, .jpeg, .png, .pdf, .mp3, .mp4"
            formControlName="arquivos"
            (change)="OnFileChange($event)"
            multiple
          />
          <label
            for="arquivos"
            class="message-container"
            *ngIf="files.length === 0"
          >
            Nenhum arquivo escolhido
          </label>
          <label
            for="arquivos"
            class="message-container"
            *ngIf="files.length > 0"
          >
            Selecionar mais arquivos
          </label>
        </div>

        <div *ngIf="files.length > 0" class="imagem-escolhida">
          <h1>Anexos Adicionados</h1>
          <div *ngFor="let file of files; let i = index">
            <app-card-arquivo-anexado
              [arquivo]="file"
              [index]="i"
              (visualizar)="visualizarAquivo($event)"
              (download)="DownloadArquivo($event)"
              (remover)="popupremoverarquivo($event)"
            ></app-card-arquivo-anexado>
          </div>
        </div>
      </div>

      <div class="container-btns">
        <input type="button" class="btn_outline" (click)="onVoltar()" value="Cancelar" />
        <input type="submit" class="btn_primary" value="Salvar" />
      </div>
    </div>
  </form>
</section>

<app-modal *ngIf="showModalAluno">
  <form [formGroup]="formModalAluno" (submit)="OnAdicionarEnvolvido()">
    <div class="container-conviva form-registro modal-envolvidos">
      <div>
        <h1 class="titulo-page">Busca Alunos</h1>
      </div>

      <div class="time-line conteudo-registro modal-conteudo-busca-aluno">
        <div>
          <div class="modal-conteudo-busca-aluno">
            <div class="grupo-filter-modal">
              <p><b>URE</b></p>
              <ng-select
                [items]="diretorias"
                bindLabel="nomeDiretoria"
                bindValue="codigoDiretoria"
                placeholder="Selecione uma URE"
                formControlName="codigoDiretoriaModal"
                name="codigoDiretoriaModal"
                (change)="getEscolasModalEnvolvidos()"
              >
              </ng-select>
            </div>

            <div class="grupo-filter-modal">
              <p><b>Escola</b></p>
              <ng-select
                [items]="escolasModalAlunos"
                bindLabel="nomeEscola"
                bindValue="codigoEscola"
                placeholder="Selecione uma Escola"
                formControlName="codigoEscolaModal"
                name="codigoEscolaModal"
              >
              </ng-select>
            </div>

            <div class="conteudo-search">
              <input
                type="text"
                placeholder="Buscar por nome ou RA"
                id="js-input-search"
                formControlName="raNomeAluno"
                name="raNomeAluno"
              />
              <button
                type="button"
                id="btnPesquisaAluno"
                (click)="BuscarAlunoPorNomeRA()"
              >
                <img src="../../../assets/img/icons/icon-search.svg" alt="" />
              </button>
            </div>
            @if(showDropAuxiliar){
            <div>
              <div class="grupo-filter-modal">
                <p><b>Estudantes</b></p>
                <ng-select
                  [items]="alunos"
                  bindLabel="nomeAluno"
                  bindValue="ra"
                  placeholder="Selecione o Aluno"
                  formControlName="raAlunoModalDrop"
                  name="raAlunoModalDrop"
                >
                </ng-select>
              </div>
            </div>
            }
          </div>
        </div>
        <div class="container-btns">
          <input
            type="button"
            (click)="FecharModalAluno()"
            class="btn_outline"
            value="Fechar"
          />
          <input type="submit" class="btn_primary" value="Salvar" />
        </div>
      </div>
    </div>
  </form>
</app-modal>

<app-modal *ngIf="showModalEquipeEscolar">
  <form
    [formGroup]="formModalEquipeEscolar"
    (submit)="OnAdicionarEquipeEscolar()"
  >
    <div class="container-conviva form-registro modal-envolvidos">
      <div>
        <h1 class="titulo-page">Dados do Equipe Escolar</h1>
      </div>
      <div class="time-line conteudo-registro modal-conteudo-busca-aluno">
        <div *ngIf="mostrarDivEquipeEscolar">
          <div class="modal-conteudo-busca-aluno">
            <div class="conteudo-search">
              <input
                type="text"
                placeholder="Digite o CPF"
                id="js-input-search"
                formControlName="cpfFuncionario"
                name="cpfFuncionario"
                mask="000.000.000-00"
                [validation]="true"
              />
              <button
                type="button"
                id="btnBuscarFuncionario"
                (click)="GetFuncionariosPorCpf(1)"
              >
                <img src="../../../assets/img/icons/icon-search.svg" alt="" />
              </button>
            </div>
            <div
              *ngIf="
                submittedModal &&
                this.formModalEquipeEscolar.get('cpfFuncionario')?.errors
              "
              class="alert"
            >
              <div
                *ngIf="
                  this.formModalEquipeEscolar.get('cpfFuncionario')?.errors
                    ?.required
                "
              >
                * CPF do funcionario é obrigatório.
              </div>
              <div
                *ngIf="
                  this.formModalEquipeEscolar.get('cpfFuncionario')?.errors &&
                  this.formModalEquipeEscolar.get('cpfFuncionario')?.errors
                    ?.message
                "
              >
                {{
                  this.formModalEquipeEscolar.get("cpfFuncionario")?.errors
                    ?.message
                }}
              </div>
            </div>
          </div>
          <div *ngIf="this.lstFuncionarios.length > 0">
            <div class="grupo-filter">
              <p><b>Funcionario</b></p>
              <ng-select
                [items]="lstFuncionarios"
                bindLabel="nome"
                bindValue="cpf"
                placeholder="Selecione o funcionario"
                formControlName="cpfFuncionarioModalDrop"
                name="cpfFuncionarioModalDrop"
              >
              </ng-select>
              <div
                *ngIf="
                  submittedModal &&
                  formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.errors
                "
                class="alert"
              >
                <div
                  *ngIf="
                    formModalEquipeEscolar.get('cpfFuncionarioModalDrop')
                      ?.errors?.required
                  "
                >
                  * Nenhum funcionario foi selecionado.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-btns">
          <input
            type="button"
            (click)="FecharModalEquipeEscolar()"
            class="btn_outline"
            value="Fechar"
          />
          <input
            type="submit"
            class="btn_primary"
            value="Salvar"
            [disabled]="
              !this.formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.value
            "
          />
        </div>
      </div>
    </div>
  </form>
</app-modal>

<app-modal *ngIf="showModalOutros">
  <form [formGroup]="formModalOutros" (submit)="OnAdicionarOutros()">
    <div class="container-conviva form-registro modal-envolvidos">
      <div>
        <h1 class="titulo-page">Dados do Outros</h1>
      </div>
      <div class="time-line conteudo-registro modal-conteudo-busca-aluno">
        <div *ngIf="mostrarDivOutros" class="conteudo-textarea">
          <label for="text-registro">Descreva quem são os outros</label>
          <textarea
            id="text-registro"
            name="text-registro"
            rows="6"
            cols="50"
            formControlName="dsOutros"
            name="dsOutros"
          ></textarea>
          <div
            *ngIf="submittedModal && formModalOutros.get('dsOutros')?.errors"
            class="alert"
          >
            <div *ngIf="formModalOutros.get('dsOutros')?.errors?.required">
              * Descricao de outros é obrigatório.
            </div>
            <div *ngIf="formModalOutros.get('dsOutros')?.errors?.maxlength">
              * O maximo de caracteres são 225.
            </div>
          </div>
        </div>

        <div class="container-btns">
          <input
            type="button"
            (click)="FecharModalOutros()"
            class="btn_outline"
            value="Fechar"
          />
          <input type="submit" class="btn_primary" value="Salvar" />
        </div>
      </div>
    </div>
  </form>
</app-modal>

<app-modal *ngIf="showModalDeletarArquivo">
  <div class="container-conviva form-registro modal-envolvidos">
    <div>
      <h1 class="titulo-page">Tem certeza que deseja excluir o anexo?</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span>Atenção: </span>não será possível desfazer esta ação.<br><br>
      <span>Detalhes</span><br>
      {{arquivoRemover?.nomeOriginal}}<br>
    </div>
    <div class="container-btns">
      <input
        type="button"
        (click)="FecharModalDeletarArquivo()"
        class="btn_outline"
        value="Cancelar"
      />
      <input
        type="button"
        (click)="removeFile()"
        class="btn_primary"
        value="Confirmar"
      />
    </div>
    </div>
  </app-modal>

<app-modal *ngIf="showModalVisualizarArquivo && arquivoVisualizando">
  <app-visualizar-arquivo
    [arquivo]="arquivoVisualizando"
    (fechar)="fecharModalVisualizarArquivo()"
  ></app-visualizar-arquivo>
</app-modal>
